/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken } from "@lib/shared/cookies";
import { Field } from "@lib/shared/types";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

export type ValidationBody =
    | {
          ruleName: Field["validationType"] | string;
          value: string;
          countryCode?: string;
          stateCode?: string;
      }
    | {
          ruleName: "fullName";
          value: { firstName: string; lastName: string };
          countryCode?: string;
      };

export interface ValidationResponse {
    success: boolean;
    data: {
        value: string | { [x: string]: string };
        replaceValue: boolean;
    } | null;
}

export const validateField = async (
    data: ValidationBody,
): Promise<{
    data: ValidationResponse["data"] | null;
    error: Error | null;
}> => {
    const accessToken = getAccessToken();

    const { ruleName, value, countryCode } = data;

    const config: AxiosRequestConfig = {
        method: "post",
        url: `/api/validation`,
        data: {
            rule: {
                name: ruleName,
                countryCode: countryCode ?? "US",
                value,
                ...(ruleName === "email"
                    ? { domains: ["trafficbox.com"] }
                    : {}),
            },
            isSoft: true,
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
        },
    };

    const { data: validationResponse, error } =
        await apiHandler<ValidationResponse>(() => HTTP.client(config));

    return {
        data: validationResponse?.data ?? null,
        error,
    };
};
